// src/features/service/serviceReducer.js
import { createReducer } from '@reduxjs/toolkit';
import {
    clearMessages,
    getServicesStart, getServicesSuccess, getServicesFailure,
    getServiceDetailsStart, getServiceDetailsSuccess, getServiceDetailsFailure,
} from './serviceActions';

const initialState = {
    services: null,
    serviceDetails: null,
    loading: false,
    successMessage: null,
    errorMessage: null,
};

const serviceReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(clearMessages, (state) => {
            state.successMessage = null;
            state.errorMessage = null;
        })
        .addCase(getServicesStart, (state) => {
            state.loading = true;
            state.successMessage = null;
            state.errorMessage = null;
        })
        .addCase(getServicesSuccess, (state, action) => {
            state.loading = false;
            state.services = action.payload.data;
            state.successMessage = action.payload.message;
        })
        .addCase(getServicesFailure, (state, action) => {
            state.loading = false;
            state.errorMessage = action.payload.message;
        })
        .addCase(getServiceDetailsStart, (state) => {
            state.loading = true;
            state.successMessage = null;
            state.errorMessage = null;
        })
        .addCase(getServiceDetailsSuccess, (state, action) => {
            state.loading = false;
            state.serviceDetails = action.payload.data;
            state.successMessage = action.payload.message;
        })
        .addCase(getServiceDetailsFailure, (state, action) => {
            state.loading = false;
            state.errorMessage = action.payload.message;
        });
});

export default serviceReducer;